<template>
	<div class="flex flex-col min-h-screen">
		<div class="flex flex-1">
			<Sidebar v-if="!isPublicRoute"></Sidebar>

			<div class="flex-1 min-w-0" :class="{ 'bg-gray-100': !isPublicRoute }">
				<Navbar @toggleMobileMenu="showMobileMenu = true" v-if="!isPublicRoute"></Navbar>

				<template v-if="!isPublicRoute">
					<PaymentFailedBanner />
					<TrialBanner />
				</template>

				<div :class="[contentClass, { 'pb-20 md:pb-0': !isPublicRoute }]">
					<router-view v-slot="{ Component }">
						<Suspense timeout="0">
							<template #default>
								<component :is="Component" />
							</template>
							<template #fallback>
								<Loading></Loading>
							</template>
						</Suspense>
					</router-view>
				</div>
			</div>
		</div>

		<template v-if="!isPublicRoute">
			<MobileDrawer :show="showMobileMenu" @close="showMobileMenu = false" />
			<MobileDock />
		</template>
	</div>
</template>

<style scoped>
	.slide-fade-enter-active {
		transition: all 0.2s ease-out;
	}

	.slide-fade-leave-active {
		transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter-from,
	.slide-fade-leave-to {
		transform: translateX(-20px);
		opacity: 0;
	}
</style>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Navbar from '@/components/Navbar';
import Loading from '@/components/Loading';
import TrialBanner from '@/components/TrialBanner.vue';
import PaymentFailedBanner from '@/components/PaymentFailedBanner.vue';
import MobileDrawer from '@/components/MobileDrawer.vue';
import MobileDock from '@/components/MobileDock.vue';
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

const PUBLIC_ROUTE_NAMES = ['auth', 'login', 'createAccount', 'checkoutSuccess', 'checkoutCancel', 'acceptInvite', 'forgotPassword'];

export default {
	components: {
		Sidebar,
		Navbar,
		Loading,
		TrialBanner,
		PaymentFailedBanner,
		MobileDrawer,
		MobileDock
	},
	setup() {
		const isLogged = ref(false);
		const showMobileMenu = ref(false);
		const route = useRoute();
		let routeName = ref(route.name);

		watch(() => route.name, () => {
			routeName.value = route.name;
		}, { immediate: true });

		watch(() => route.fullPath, () => {
			showMobileMenu.value = false;
		});

		const isPublicRoute = computed(() =>
			PUBLIC_ROUTE_NAMES.includes(routeName.value) ||
			(typeof routeName.value === 'string' && routeName.value.startsWith('admin'))
		);

		const contentClass = computed(() => {
			if (isPublicRoute.value) return '';
			if (['subscription', 'account', 'usageLimits', 'users', 'home', 'patientForm', 'records', 'evaluations', 'recordConclusion'].includes(routeName.value)) return 'px-4 py-4 sm:px-6 lg:px-8 lg:py-4';
			return 'p-4 md:p-10';
		});

		return { isLogged, showMobileMenu, routeName, isPublicRoute, contentClass };
	}
}
</script>
